import { Reveal } from "./Reveal";
import { Recycle, FlaskConical, Cpu } from "lucide-react";

const objectives = [
  {
    icon: Recycle,
    title: "Non-Ferrous Recycling",
    body: "Extend our closed-loop recycling to zinc, aluminium, copper and other non-ferrous metals.",
  },
  {
    icon: FlaskConical,
    title: "Minor Metal Refining",
    body: "Build dedicated refining capability for strategic minor metals recovered from our streams.",
  },
  {
    icon: Cpu,
    title: "E-Waste Recycling",
    body: "Establish responsible electronic-waste recovery for precious and base metals.",
  },
];

export const Vision = () => (
  <section
    id="vision"
    data-testid="vision-section"
    className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40"
  >
    <Reveal>
      <div className="mb-12 flex items-center gap-4 font-mono-tech text-xs uppercase tracking-[0.25em] text-[var(--mx-ink-2)]">
        <span className="h-px w-10 bg-[var(--mx-copper)]" />
        06 — Vision &amp; Objectives
      </div>
    </Reveal>

    <Reveal delay={0.05}>
      <div className="relative overflow-hidden rounded-3xl bg-[var(--mx-charcoal)] p-8 md:p-16">
        <div className="pointer-events-none absolute -right-16 -top-16 h-72 w-72 rounded-full bg-[var(--mx-copper)]/25 blur-[90px]" />
        <div className="pointer-events-none absolute -bottom-20 left-1/3 h-72 w-72 rounded-full bg-[var(--mx-teal)]/20 blur-[90px]" />
        <div className="relative z-10">
          <span className="font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-copper-soft)]">
            Our Vision
          </span>
          <p className="mt-6 max-w-4xl font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-[#f6f2ec] md:text-5xl">
            To become India&apos;s most trusted circular metals company —
            recovering value from{" "}
            <span className="text-metal">every non-ferrous stream</span> and
            returning it, cleanly, to industry.
          </p>
        </div>
      </div>
    </Reveal>

    <div className="mt-14">
      <Reveal>
        <p className="mb-8 max-w-xl font-mono-tech text-xs uppercase tracking-widest text-[var(--mx-ink-2)]">
          Objectives — where Metalix XT is headed next
        </p>
      </Reveal>
      <div className="grid gap-5 md:grid-cols-3">
        {objectives.map((o, i) => (
          <Reveal key={o.title} delay={i * 0.1}>
            <div className="group flex h-full flex-col rounded-2xl border border-[var(--mx-line)] bg-[var(--mx-surface)] p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_24px_60px_-40px_rgba(27,23,20,0.4)] md:p-10">
              <div className="flex items-center justify-between">
                <div className="grid h-12 w-12 place-items-center rounded-xl bg-[var(--mx-copper)]/12 text-[var(--mx-copper)] transition-colors duration-500 group-hover:bg-[var(--mx-copper)] group-hover:text-white">
                  <o.icon size={22} strokeWidth={1.6} />
                </div>
                <span className="rounded-full border border-[var(--mx-line-strong)] px-3 py-1 font-mono-tech text-[10px] uppercase tracking-widest text-[var(--mx-ink-2)]">
                  Roadmap
                </span>
              </div>
              <h3 className="mt-8 font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-[var(--mx-ink)] md:text-3xl">
                {o.title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-[var(--mx-ink-2)]">
                {o.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Vision;
